<template>
  <adivare-input
    @validation-request="validateField"
    :outer-class="outerClass"
    :input-class="inputClass"
    :legend-class="legendClass"
    :show-property="showProperty"
    :label-class="labelClass"
    :property-name="propertyName"
    :placeholder="fieldLabel"
    :form-type="formType"
    :field-label="fieldLabel"
    :optional="optional"
    :autocomplete="autocomplete"
    :special-error="showSpecialErrorMessage"
  />
</template>

<script>
import formMixin from "../../../mixins/form-mixin"
import { empty } from "../../../../../js/util/util-functions";
import AdivareAlert from '../../../../components/alert';

export default {
  name: "adivare-address-form-element",
  mixins: [
    formMixin,
  ],
  components: {
    AdivareAlert,
  },
  props: {
    showProperty: {
      required: false,
      default: true,
      type: Boolean,
    },
  },
  computed: {
    houseNumber() {
      return this.$refs.customerHouseNumber.value;
    },
    addressIsValid() {
      return this.$store.getters.addressIsValid;
    },
    showSpecialErrorMessage() {
      return false === this.addressIsValid &&
        this.$store.getters.getFormField('customerHouseNumber') > 0 &&
        null !== this.$store.getters.getFormField('customerPostcode') &&
        this.$store.getters.getFormField('customerPostcode').length > 3
    },
    errorMessage() {
      return false === this.$store.getters.getFormFieldValidityState(this.propertyName)
        ? this.$t('messages_nl.label.cancellation.userLetter.houseNumber.error')
        : '';
    },
  },
  methods: {
    validateField(value) {
      let valid = false === empty(value);
      switch (this.propertyName) {
        case 'customerPostcode':
          valid &= /^[0-9]{4}\s?[A-Za-z]{2}$/.test(value) || /^[0-9]{4}$/.test(value);
          break;
        case 'customerHouseNumber':
          valid &= value;
          break;
      }
      this.$store.dispatch('validateAddress')
      // .then(() => {
      this.$store.commit('updateFormFieldValidity', {
        name: this.propertyName,
        valid
      });
      // });
    },
  },
}
</script>
